import { Grid, ListItemText } from "@mui/material";
import { VoiceMessage, Feature } from "types/api";

export interface VoiceMessageLITextProps {
  voiceMessage: VoiceMessage;
}

export const VoiceMessageLIText: React.FC<VoiceMessageLITextProps> = ({ voiceMessage: msg }) => (
  <>
    <Grid container>
      <Grid item xs={4}>
        <ListItemText primary={featureName(msg)} secondary={msg.title} />
      </Grid>
    </Grid>
  </>
);

export function featureName(voiceMessage: VoiceMessage): string {
  return voiceMessage.feature !== Feature.Instructions
    ? "Activity"
    : voiceMessage.cognitiveDomains?.[0] ?? "-";
}
